import axiosInstance from '@/services/axiosInstance'

async function eliminarAnexo (idAnexo) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: 'api/adjuntos/eliminaranexo?idAnexo=' + idAnexo,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        'access-control-allow-origin': '*'
      },
      data: {
        idAnexo: idAnexo
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { eliminarAnexo }
